export default __webpack_public_path__ + "static/media/img-2-removebg-preview.3bb77b62.png";